// @flow

import type {TreeStructure} from '../typedef';

export const filterMatchedData = (
    data: TreeStructure,
    searchValue: string,
    includeChildren?: boolean
): TreeStructure => (
    data
        .filter(currentData => !currentData.transient)
        .map(currentData => {
            let children = [];
            const caption = currentData.caption && currentData.caption.toLowerCase() || '';
            const captionMatchedSearch = caption.includes(searchValue);
            let matchedSearch = includeChildren || captionMatchedSearch;

            if (currentData.children) {
                children = filterMatchedData(currentData.children, searchValue, matchedSearch);
            }
            matchedSearch = matchedSearch || children.some(item => item.matchedSearch);

            return {
                ...currentData,
                ...(children.length ? {children} : {}),
                matchedSearch,
                captionMatchedSearch: captionMatchedSearch && searchValue.length > 0
            };
        })
);
